import React from 'react';
import { Link } from "react-router-dom";
import '../../style/scss/BreadCrumb.scss';
//


// export function SiteMap(props) {
//    
//    return {
//       props: props,
//       push: (label,route) => {
//          navigate.push(route);
//       },
//       pop: (count) => {
//       },
//       renderBreadcrumb: e=> {
//          let parts = (props && props.props && props.props.length>0 &&  props.props.map((p,i)=>{
//             if(typeof p == 'object')
//                return { route: p.route || p.label, label: p.label || p.route };
//             if(typeof p == 'string') {
//                return { route: p, label: p};
//             }
//             return 'n/a';
//          })); 
//          return (
//             <ol className="breadcrumb">
//                <li key="0"><Link to="/">Home</Link></li>
//                {parts?parts.map((part,index) => { 
//                if(index<parts.length-1)
//                   return <li key={index}><Link to={part.route}>{part.label}</Link></li>
//                return <li key={index}>{part.label}</li>
//              }):""}</ol>
//          );
//       }
//    }
// }


export default function BreadCrumb(props) {
   var parts = (props && props.props && props.props.length>0 &&  props.props.map((p,i)=>{
      if(typeof p == 'object')
         return { route: p.route || "", label: p.label || p.route || "" };
      if(typeof p == 'string') {
         return { route: "", label: p};
      }
      return 'n/a';
   }));

   return (
      <ol className="breadcrumb">
         <li key="0"><Link to="/">Home</Link></li>
         {parts?parts.map((part,index) => { 
         if(index<parts.length-1 && part.route)
            return <li key={index}><Link to={part.route}>{part.label}</Link></li>
         return <li key={index}>{part.label}</li>
       }):""}</ol>
   );
}


